import { MyButton, MyCheckbox } from '@interstellar-component'
import { ArrowLeft, ChevronDown } from '@untitled-ui/icons-react'
import React, { useEffect, useRef, useState } from 'react'
import SimpleBar from 'simplebar-react'
import { useRegister } from '../Context'

function TermsConditions({ onBack, onAccept, accepted, setAccepted, isSubmitting }) {
  const { register } = useRegister()
  // Ref to SimpleBar's scrollable node, used to drive the scroll-down chevron.
  const scrollRef = useRef(null)
  // Show the chevron only while there is more content to scroll into view;
  // it auto-hides once the user reaches the bottom of the terms.
  const [showScrollHint, setShowScrollHint] = useState(false)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return undefined
    const update = () => {
      const { scrollTop, scrollHeight, clientHeight } = el
      const scrollable = scrollHeight - clientHeight > 8
      const atBottom = scrollTop + clientHeight >= scrollHeight - 8
      setShowScrollHint(scrollable && !atBottom)
    }
    update()
    el.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      el.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [])

  // Smooth-scroll the terms down by ~80% of the viewport on each click.
  const scrollDown = () => {
    const el = scrollRef.current
    if (!el) return
    el.scrollBy({ top: el.clientHeight * 0.8, behavior: 'smooth' })
  }
  // Effective date shown in the header ("Current as of") and the first section
  // ("Berlaku sejak") — the current date rendered in the client's local timezone.
  // Intl.DateTimeFormat without an explicit timeZone uses the browser's zone, so
  // the displayed date matches the user's wall-clock day. Same value in both spots.
  const effectiveDate = new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date())
  const sections = [
    {
      // heading: 'Lorem ipsum delarus?',
      content: `Berlaku sejak: ${effectiveDate}\n\nSelamat datang di Platform Everest. Dengan mendaftarkan akun dan menggunakan layanan kami, Perusahaan dan seluruh pengguna yang didaftarkan ("Pengguna") menyatakan telah membaca dan menyetujui Syarat dan Ketentuan ini. Mohon baca dengan seksama sebelum melanjutkan.`,
    },
    {
      heading: '1. Tentang Platform Everest',
      content:
        'Platform Everest adalah layanan teknologi berbasis SaaS (Software as a Service) yang membantu perusahaan melakukan pengecekan latar belakang karyawan dan kandidat rekrutmen melalui integrasi dengan penyedia data pihak ketiga yang telah memiliki izin resmi.\nPT Solusi Adikarya Wisesa ("SAW") berperan semata-mata sebagai penyedia platform teknologi. SAW tidak memberikan rekomendasi, penilaian, maupun keputusan apapun atas individu yang dicek. Seluruh keputusan yang diambil berdasarkan hasil pengecekan sepenuhnya merupakan tanggung jawab Perusahaan.',
    },
    {
      heading: '2. Pendaftaran dan Akun',
      content:
        'Perusahaan wajib memberikan informasi yang benar dan lengkap saat mendaftarkan akun. Perusahaan bertanggung jawab penuh atas keamanan akun dan seluruh aktivitas yang terjadi melalui akun tersebut, termasuk aktivitas seluruh Pengguna yang didaftarkan.\nSetiap Pengguna yang diberikan akses wajib menandatangani Form Persetujuan Pengguna Platform sebelum akses diberikan. Kewajiban ini sepenuhnya ada di pihak Perusahaan.',
    },
    {
      heading: '3. Ketentuan Penggunaan',
      content:
        'Platform hanya boleh digunakan untuk keperluan pengecekan latar belakang yang sah dalam lingkup rekrutmen dan evaluasi karyawan. Perusahaan dan Pengguna dilarang:\n• Menggunakan Platform untuk tujuan yang melanggar hukum;\n• Melakukan Inquiry tanpa persetujuan yang sah dari individu yang bersangkutan;\n• Menyebarkan atau membagikan hasil Inquiry kepada pihak yang tidak berwenang;\n• Menggunakan data yang diperoleh untuk kepentingan pribadi di luar keperluan resmi perusahaan;\n• Melakukan tindakan diskriminatif terhadap individu berdasarkan data yang diperoleh dari Platform;\n• Mencoba mengakses, memodifikasi, mendekompilasi, atau melakukan reverse engineering terhadap Platform, source code, algoritma, atau komponen teknis apapun milik SAW;\n• Menggunakan Platform untuk mengembangkan produk atau layanan yang bersaing dengan Platform Everest.',
    },
    {
      heading: '4. Subscription dan Pembayaran',
      content:
        '4.1 Layanan Platform tersedia berdasarkan skema berlangganan (subscription) sesuai paket yang dipilih Perusahaan pada saat pendaftaran.\n4.2 Pembayaran dilakukan di muka sesuai siklus billing yang disepakati. Keterlambatan pembayaran dapat mengakibatkan penangguhan akses Platform tanpa pemberitahuan terlebih dahulu.\n4.3 Seluruh pembayaran yang telah dilakukan bersifat non-refundable, kecuali ditentukan lain secara tertulis oleh SAW.\n4.4 SAW berhak melakukan penyesuaian harga dengan memberikan pemberitahuan tertulis kepada Perusahaan minimal 30 hari kalender sebelum perubahan harga berlaku. Penggunaan Platform setelah tanggal berlakunya perubahan harga dianggap sebagai penerimaan atas perubahan tersebut.\n4.5 Biaya per Inquiry dikenakan berdasarkan tarif yang berlaku pada saat Inquiry dilakukan dan akan secara otomatis mengurangi saldo atau ditagihkan sesuai mekanisme billing yang disepakati.',
    },
    {
      heading: '5. Tanggung Jawab atas Hasil Pengecekan',
      content:
        'Hasil Inquiry yang ditampilkan di Platform merupakan data yang diperoleh dari penyedia data pihak ketiga. SAW tidak menjamin kebenaran, kelengkapan, atau kesesuaian data tersebut untuk tujuan apapun.\nSeluruh interpretasi, analisis, dan keputusan yang diambil berdasarkan hasil Inquiry — termasuk keputusan rekrutmen atau evaluasi karyawan — sepenuhnya menjadi tanggung jawab Perusahaan. SAW tidak dapat dimintai pertanggungjawaban atas dampak apapun yang timbul dari keputusan tersebut.',
    },
    {
      heading: '6. Perlindungan Data Pribadi',
      content:
        'Perusahaan wajib memastikan bahwa setiap Inquiry dilakukan berdasarkan persetujuan yang sah dari individu yang bersangkutan, sesuai dengan Undang-Undang Nomor 27 Tahun 2022 tentang Perlindungan Data Pribadi dan peraturan terkait lainnya.\nPerusahaan bertanggung jawab penuh atas keabsahan persetujuan tersebut dan penggunaan data sesuai dengan tujuan yang telah dikomunikasikan kepada individu bersangkutan. SAW tidak bertanggung jawab atas pelanggaran perlindungan data pribadi yang dilakukan oleh Perusahaan atau Pengguna.',
    },
    {
      heading: '7. Kepemilikan Data',
      content:
        '7.1 Data yang di-input oleh Perusahaan ke dalam Platform tetap menjadi milik Perusahaan sepenuhnya. SAW tidak mengklaim kepemilikan atas data tersebut.\n7.2 SAW berhak menggunakan data secara agregat dan anonim (tanpa dapat diidentifikasi ke Perusahaan atau individu tertentu) untuk keperluan peningkatan layanan Platform.\n7.3 Setelah akun Perusahaan dinonaktifkan atau berakhir, SAW akan menghapus seluruh data Perusahaan dalam waktu 30 hari kalender, kecuali diwajibkan lain oleh peraturan perundang-undangan yang berlaku.',
    },
    {
      heading: '8. Batasan Tanggung Jawab SAW',
      content:
        'SAW tidak bertanggung jawab atas kerugian, tuntutan, atau dampak yang timbul dari:\n• Keputusan yang diambil Perusahaan atau Pengguna berdasarkan hasil Inquiry;\n• Kebocoran data atau penyalahgunaan yang terjadi dari sisi akun, perangkat, atau jaringan Perusahaan atau Pengguna;\n• Keterlambatan, kegagalan, atau ketidakakuratan data dari penyedia data pihak ketiga;\n• Kegagalan Perusahaan dalam memperoleh persetujuan yang sah dari individu sebelum melakukan Inquiry;\n• Pelanggaran peraturan perundang-undangan yang dilakukan oleh Perusahaan atau Pengguna;\n• Gangguan layanan akibat force majeure, termasuk namun tidak terbatas pada bencana alam, pandemi, gangguan infrastruktur nasional, atau tindakan pemerintah.',
    },
    {
      heading: '9. Kerahasiaan',
      content:
        'Perusahaan dan Pengguna wajib menjaga kerahasiaan seluruh informasi yang diperoleh melalui Platform, termasuk hasil Inquiry, kredensial akses, dan informasi teknis Platform. Kewajiban ini tetap berlaku selama 2 tahun setelah akses Platform berakhir.',
    },
    {
      heading: '10. Penangguhan dan Penghentian Akses',
      content:
        'SAW berhak menangguhkan atau menghentikan akses Platform apabila terdapat pelanggaran Syarat dan Ketentuan ini, indikasi penyalahgunaan Platform atau data, kegagalan pembayaran, atau perintah dari otoritas yang berwenang. Penghentian akses tidak membebaskan Perusahaan dari kewajiban yang telah timbul sebelumnya.',
    },
    {
      heading: '11. Perubahan Syarat dan Ketentuan',
      content:
        'SAW dapat memperbarui Syarat dan Ketentuan ini sewaktu-waktu. Perubahan akan diberitahukan melalui email terdaftar atau notifikasi dalam Platform minimal 14 hari kalender sebelum berlaku. Penggunaan Platform setelah perubahan berlaku dianggap sebagai penerimaan atas perubahan tersebut.',
    },
  ]

  return (
    <section className="flex h-full w-full items-center justify-center px-8 pb-8 pt-12 lg:px-16 lg:pb-16 lg:pt-24">
      <div className="flex h-full max-w-3xl flex-col gap-6 bg-white antialiased">
        <div className="flex flex-col gap-6">
          <MyButton
            variant="link"
            color="primary"
            onClick={onBack}
            className="!text-primary-700 h-fit w-fit p-0"
          >
            <div className="flex items-center gap-2">
              <ArrowLeft size={20} />
              <p className="text-sm-semibold">Back to previous page</p>
            </div>
          </MyButton>

          <div className="flex flex-col gap-1 border-b border-gray-200 pb-5">
            <p className="display-sm-semibold text-gray-900">
              Terms and conditions
            </p>
            <p className="text-sm-regular text-gray-600">
              Current as of {effectiveDate}
            </p>
          </div>
        </div>

        <div
          className="flex flex-1 flex-col gap-6 overflow-hidden"
          id="tnc-contents"
        >
          <div className="flex-1 overflow-hidden">
            <SimpleBar
              className="h-full"
              style={{ maxHeight: '100%' }}
              scrollableNodeProps={{ ref: scrollRef }}
            >
              <div className="flex flex-col gap-8 pr-2">
                {sections.map((section, index) => (
                  <div key={index} className="flex flex-col gap-4">
                    {section.heading && (
                      <p className="text-lg-semibold text-gray-900">
                        {section.heading}
                      </p>
                    )}
                    <div className="text-md-regular whitespace-pre-line text-gray-600">
                      {section.content}
                    </div>
                  </div>
                ))}
              </div>
            </SimpleBar>
          </div>

          <div className="mt-auto flex flex-col gap-6">
            <div className={`flex items-center ${showScrollHint ? 'gap-4' : ''}`}>
              <div className="h-px flex-1 bg-gray-200" />
              {showScrollHint && (
                <button
                  type="button"
                  onClick={scrollDown}
                  aria-label="Scroll untuk membaca selengkapnya"
                  className="flex h-8 w-8 items-center justify-center rounded-full text-gray-600 transition hover:bg-gray-100"
                >
                  <ChevronDown size={20} />
                </button>
              )}
              <div className="h-px flex-1 bg-gray-200" />
            </div>
            <div className="flex items-center gap-3">
              <MyCheckbox
                checked={accepted}
                onChangeForm={(e) => setAccepted(e.target.checked)}
              />
              <p className="text-sm-regular text-gray-900">
                Dengan menyetujui ini, Anda menyatakan telah membaca dan
                menyetujui syarat & ketentuan yang berlaku.
              </p>
            </div>

            <MyButton
              type="submit"
              variant="filled"
              color="primary"
              size="lg"
              expanded
              disabled={!accepted || isSubmitting}
              // onClick={onAccept}
            >
              <p className="text-md-semibold">Kirim pengajuan</p>
            </MyButton>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsConditions
